const isBrowser = () => typeof window !== "undefined"

export const isEditMode = () => {
  if (isBrowser() && window.location.search.includes("_storyblok")) {
    return true
  }

  return false
}
